import React from "react";
import { connect } from "react-redux";
import * as Actions from "../store/actions/index";
import Downshift from "downshift";
import TextField from "material-ui/TextField";
import { MenuItem } from "material-ui/Menu";
import Paper from "material-ui/Paper";
import Icon from "./graphics/Icon";
import matchSorter from "match-sorter";
import $ from "jquery";
import device from "current-device";
import styled from "styled-components";
import get from "lodash/get";
import concat from "lodash/concat";
import usePlacesAutocomplete, {
  getGeocode,
  getLatLng
} from "use-places-autocomplete";

const Suggestions = styled(Paper)`
  @media (orientation: portrait) {
    &.suggestions {
      z-index: 1;
      transform: translateY(calc(-100% - 39px));
      overflow-y: scroll;
      display: flex;
      flex-direction: column;
      flex-flow: column-reverse;
      flex-wrap: wrap;

      div {
        font-size: 12px;
        padding-top: 8px;
        padding-bottom: 8px;
        width: calc(100% - 32px);
      }
    }
  }
`;

const ClearBtn = styled.span`
  z-index: 100;
  cursor: pointer;
`;

const style = {
  position: "absolute",
  width: "100%",
  zIndex: 5,
  maxHeight: "220px",
  overflowY: "scroll"
};

const SearchBox = (props) => {
  const {
    suggestions: { data: autocompleteResults },
    setValue,
    clearSuggestions: clearAutocompleteSuggestions
  } = usePlacesAutocomplete({
    requestOptions: {
      radius: 48281, // meters.  30 miles
      location: new window.google.maps.LatLng(
        props.centerOfMap.lat,
        props.centerOfMap.lng
      )
    },
    debounce: 300
  });

  const getAutoCompleteResultLatLng = async (placeId) => {
    try {
      const geocodeResults = await getGeocode({ placeId });
      const latLng = await getLatLng(geocodeResults[0]);
      return latLng;
    } catch (e) {
      return {};
    }
  };

  const updateMap = (center) => {
    if (center) {
      const { onChangeMap, onReCenterMap, wW, wH } = props;

      if (wW < 600 && wH > wW) {
        onReCenterMap(center.lat, center.lng, 15);
      } else {
        onChangeMap({
          center,
          zoom: 14
        });
      }
    }
  };

  const handleChange = async (selectedItem) => {
    const {
      onAddItem,
      onRemoveItem,
      searched,
      resultsShown,
      onShowResults,
      onExpandMap,
      onSetGooglePlaceItem
    } = props;
    if (selectedItem) {
      if (device.mobile() || device.tablet()) {
        $("#beach-report-search").blur();
      }
      onAddItem(selectedItem);
      onExpandMap(false);
      searched(true);
      if (!resultsShown) onShowResults(true);
      if (selectedItem.place_id) {
        const latLng = await getAutoCompleteResultLatLng(selectedItem.place_id);
        if (latLng.lat && latLng.lng) {
          onSetGooglePlaceItem({
            description: selectedItem.description,
            ...latLng
          });
        }
      } else {
        updateMap({ lat: selectedItem.lat, lng: selectedItem.lng });
      }
    } else {
      onRemoveItem();
    }
  };

  const getItems = (value) => {
    const { locations } = props;

    return value
      ? concat(
          matchSorter(locations, value, {
            keys: ["title", "name1", "name2", "name3"]
          }),
          autocompleteResults
        )
      : concat(locations, autocompleteResults);
  };

  const onInputValueChange = async (searchTerm) => {
    if (searchTerm.length > 3) {
      setValue(searchTerm);
    }
  };

  /**
   * @param  item location or autocomplete result
   * @description Tries to pull title from location, if not found description from autocomplete result.
   * Returns empty string if neither exists.
   * @returns string
   */
  const itemToString = (item) =>
    get(item, "title", get(item, "description", ""));

  return (
    <div>
      <Downshift
        onInputValueChange={onInputValueChange}
        onChange={handleChange}
        itemToString={itemToString}>
        {({
          getInputProps,
          getItemProps,
          isOpen,
          clearSelection,
          selectedItem,
          inputValue,
          highlightedIndex
        }) => (
          <div>
            <TextField
              {...getInputProps({
                placeholder: "Search For Your Favorite Beach",
                fullWidth: true,
                id: "beach-report-search",
                onFocus: clearSelection
              })}
            />
            {selectedItem ? (
              <ClearBtn
                onClick={() => {
                  clearAutocompleteSuggestions();
                  clearSelection();
                }}>
                <Icon name="clear" aria-label="clear selection" />
              </ClearBtn>
            ) : (
              <Icon name="search" />
            )}
            {isOpen ? (
              <Suggestions style={style} className="suggestions" square>
                {getItems(inputValue).map((item, index) => (
                  <MenuItem
                    key={`search_result_${index}`}
                    {...getItemProps({
                      item,
                      index
                    })}
                    selected={highlightedIndex === index}
                    component="div">
                    {itemToString(item)}
                  </MenuItem>
                ))}
              </Suggestions>
            ) : null}
          </div>
        )}
      </Downshift>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    locations: state.brc.locations,
    selectedItem: state.brc.selectedItem,
    resultsShown: state.brc.resultsShown,
    searchIsOpen: state.brc.searchIsOpen,
    centerOfMap: state.brc.mapOptions.center
  };
};

export default connect(mapStateToProps, { ...Actions })(SearchBox);



// WEBPACK FOOTER //
// ./src/components/SearchBox.js